<template>
  <div>
    <iframe
      :src="URL"
      width="100%"
      height="600px"
      onload="this.height=this.contentWindow.document.body.scrollHeight;"
    ></iframe>
  </div>
</template>

<script>
import { i18n } from "../main";
export default {
  name: "lieferrecht",
  data() {
    return {
      //URL: '/dbp/'+i18n.locale+'/lieferrecht',
    };
  },
  computed: {
    URL() {
      return "/dbp/" + i18n.locale + "/lieferrecht";
      /*
            if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 768)
                return '/dbp/'+i18n.locale+'/lieferrecht1col'
            else
                return '/dbp/'+i18n.locale+'/lieferrecht'
            */
    }
  }
};
</script>